import React from "react";
import Button from "./Button";
import Ingredients from "./ingredients";
import RecipeInstructions from "./RecipeInstructions";
import Input from "./forms/Input";
import TextArea from "./forms/TextArea";
import Select from "./forms/Select";
import { useNavigate } from "react-router-dom";


const RecipeDetailEdit = ({ recipe, imageUrl, mode, onRecipeChange, onImageChange, onSave, isSaving, fieldErrors }) => {
  const navigate = useNavigate();
  const cuisines = ["", "American", "Chinese", "French", "Greek", "Indain", "Italian", "Japanese", "Korean", "Mediterranean", "Middle Eastern", "Mexican", "Spanish", "Thai", "Vietnamese", "Other"]
  const courses = ["", "Appetizer", "Beverage", "Bread", "Dessert", "Main Entrée", "Salad", "Sauce/Condiment", "Side Dish", "Snack", "Soup", "Other"]

  return (
    <div>
      <div className="mb-4">
        <Input value={recipe.title} type="text" onChange={(value) => onRecipeChange("title", value)} placeholder="Recipe Title" className="w-full text-3xl font-bold" error={fieldErrors.title} showError="true" fullWidth="true" disabled={isSaving} />
      </div>
      {/* {imageUrl ? (
        <div className="mb-12">
          <img src={imageUrl} className="w-96 rounded-lg" alt="logo" />
            <div className="mt-4 flex">
              <input type="file" onChange={(e) => onImageChange(e.target.files[0])} disabled={isSaving} />
              <Button type="secondary" onClick={() => onImageChange("")} disabled={isSaving}>Remove</Button>
            </div>
        </div>
      ) : (
        <div className="mb-12">
          <input type="file" onChange={(e) => onImageChange(e.target.files[0])} disabled={isSaving}/>
        </div>
      )} */}
      <section className="mb-12">
        <div className="mb-4">
          <div className="mb-1">
            <span className="font-bold">Serves: </span>
            <Input value={recipe.serves} type="number" onChange={(value) => onRecipeChange("serves", value)} className="w-14" error={fieldErrors.serves} showError="true" disabled={isSaving} />
          </div>
          <div className="mb-1">
            <span className="font-bold">Cook Time (min.): </span>
            <Input value={recipe.cookTime} type="number" onChange={(value) => onRecipeChange("cookTime", value)} className="w-14 mr-2" error={fieldErrors.cookTime} showError="true" disabled={isSaving} />
          </div>
          <div className="mb-1">
            <span className="font-bold">Cuisine: </span>
            <Select
              options={cuisines}
              value={recipe.cuisine}
              onChange={(value) => onRecipeChange("cuisine", value)}
              className="w-100"
              error={fieldErrors.cuisine}
              showError={true}
              disabled={isSaving}
            />
          </div>
          <div className="mb-1">
            <span className="font-bold">Course: </span>
            <Select
              options={courses}
              value={recipe.course}
              onChange={(value) => onRecipeChange("course", value)}
              className="w-100"
              error={fieldErrors.course}
              showError={true}
              disabled={isSaving}
            />
          </div>
          <div>
            <span className="font-bold">Source: </span>
            <Input value={recipe.source} type="text" onChange={(value) => onRecipeChange("source", value)} className="w-64" error={fieldErrors.source} showError="true" disabled={isSaving} />
          </div>
        </div>
        <div className="text-lg text-text-light mb-4">
          <TextArea value={recipe.description} onChange={(value) => onRecipeChange("description", value)} className="w-full" rows="4" error={fieldErrors.description} showError="true" fullWidth="true" disabled={isSaving} />
        </div>
      </section>
      <section className="mb-12">
        <Ingredients ingredients={recipe.ingredients} mode={mode} onChange={onRecipeChange} isSaving={isSaving} errors={fieldErrors.ingredients} />
      </section>
      <section className="mb-12">
        <RecipeInstructions mode={mode} instructions={recipe.instructions} onUpdate={onRecipeChange} isSaving={isSaving} errors={fieldErrors.instructions} />
      </section>
      <div className="flex gap-4">
        <Button type="primary" onClick={onSave} disabled={isSaving} isLoading={isSaving}>
          {isSaving ? "Saving..." : "Save Changes"}
        </Button>
        <Button type="secondary" disabled={isSaving} onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>
    </div>
  )
}

export default RecipeDetailEdit;